import React, { useState } from 'react'
import { withMicrositeWrapper } from '@dustin-web/microsite-nextjs/src/with-server-data/with-microsite-wrapper'
import Provider from 'src/components/layout/provider'
import RegistrationComponent from '../components/registration'
import { withMicrositeProps } from '@dustin-web/microsite-nextjs/src/with-server-data/with-microsite-props'
import { Site } from '@dustin-web/microsite-config/src/site-context'
import { ServerEnvironment } from '@dustin-web/microsite-config/src/server-settings'
import RegistrationLayout from 'src/components/layout/registrationLayout'
import { useSiteTitle, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import Head from 'next/head'
import { useAuth } from '@dustin-web/microsite-components/src/auth'

type RegistrationProps = {
  site: Site
  serverEnv: ServerEnvironment
}

export enum State {
  email,
  companyInfo,
  account,
  emailVerification,
  confirmation,
  password,
  ongoingActivation,
}

const Registration = ({ site, serverEnv }: RegistrationProps) => {
  const { translate } = useTranslations()
  const { getSiteTitle } = useSiteTitle()
   const { isAuthenticated } = useAuth()

    const [registrationState, setRegistrationState] = useState<State>(
      !isAuthenticated ? State.email : State.companyInfo
    )

  return (
    <>
      <Head>
        <title>{getSiteTitle(translate('RegistrationPageTitle'))}</title>
      </Head>

      <Provider site={site} serverEnv={serverEnv}>
        <RegistrationLayout registrationState={registrationState}>
          <RegistrationComponent setRegistrationState={setRegistrationState} registrationState={registrationState}/>
        </RegistrationLayout>
      </Provider>
    </>
  )
}

export const getServerSideProps = withMicrositeProps(async ctx => {
  const { micrositeProps } = ctx
  const { requestContext } = micrositeProps

  return {
    props: {
      site: requestContext.site,
      serverEnv: requestContext.serverEnv
    }
  }
})

export default withMicrositeWrapper(Registration)
